import { render, staticRenderFns } from "./companyPage.vue?vue&type=template&id=1c8d149d&"
import script from "./companyPage.vue?vue&type=script&lang=ts&"
export * from "./companyPage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports